import {
  MyAccountPage,
  NavigationWithUserContext,
  RequiredDashboardData,
} from "@nju/feature-portal-dashboard";
import { ResolveMyAccountPageContext } from "@nju/feature-portal-dashboard";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { BlockContent, LayoutWrapper, useOverlay } from "@nju/ui";
import { ClientSideOnly } from "../../components/ClientSideRenderer";

export default function MyAccount() {
  const fSecureModal = useOverlay();

  return (
    <LayoutWrapper>
      <Header />
      <BlockContent grid="narrow" spacing="xl" tone="gray">
        <ClientSideOnly>
          <ResolveMyAccountPageContext type="account">
            <RequiredDashboardData refreshInterval={5000}>
              {({
                handleSetSelectedNumber,
                handleSetMultiDuoTrioContext,
                handleSetMode,
                isLoading,
              }) => {
                return (
                  <>
                    <NavigationWithUserContext />
                    <MyAccountPage
                      fSecureModal={fSecureModal}
                      handleSetMode={handleSetMode}
                      handleSetMultiDuoTrioContext={
                        handleSetMultiDuoTrioContext
                      }
                      handleSetSelectedNumber={handleSetSelectedNumber}
                      isLoading={isLoading}
                    />
                  </>
                );
              }}
            </RequiredDashboardData>
          </ResolveMyAccountPageContext>
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
